import {
  search as publicSearch,
  federatedSearch as publicFederatedSearch,
  suggest as publicSuggest,
  federatedSuggest as publicFederatedSuggest,
  related as publicRelated,
  autocomplete as publicAutocomplete,
  federatedAutocomplete as publicFederatedAutocomplete,
  trending as publicTrending,
} from './search-v1-sitedocument-site-search.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const search: MaybeContext<
  BuildRESTFunction<typeof publicSearch> & typeof publicSearch
> = /*#__PURE__*/ createRESTModule(publicSearch);
export const federatedSearch: MaybeContext<
  BuildRESTFunction<typeof publicFederatedSearch> & typeof publicFederatedSearch
> = /*#__PURE__*/ createRESTModule(publicFederatedSearch);
export const suggest: MaybeContext<
  BuildRESTFunction<typeof publicSuggest> & typeof publicSuggest
> = /*#__PURE__*/ createRESTModule(publicSuggest);
export const federatedSuggest: MaybeContext<
  BuildRESTFunction<typeof publicFederatedSuggest> &
    typeof publicFederatedSuggest
> = /*#__PURE__*/ createRESTModule(publicFederatedSuggest);
export const related: MaybeContext<
  BuildRESTFunction<typeof publicRelated> & typeof publicRelated
> = /*#__PURE__*/ createRESTModule(publicRelated);
export const autocomplete: MaybeContext<
  BuildRESTFunction<typeof publicAutocomplete> & typeof publicAutocomplete
> = /*#__PURE__*/ createRESTModule(publicAutocomplete);
export const federatedAutocomplete: MaybeContext<
  BuildRESTFunction<typeof publicFederatedAutocomplete> &
    typeof publicFederatedAutocomplete
> = /*#__PURE__*/ createRESTModule(publicFederatedAutocomplete);
export const trending: MaybeContext<
  BuildRESTFunction<typeof publicTrending> & typeof publicTrending
> = /*#__PURE__*/ createRESTModule(publicTrending);

export {
  VersioningMode,
  Enum,
  WebhookIdentityType,
  Direction,
  Aggregation,
} from './search-v1-sitedocument-site-search.universal.js';
export {
  SiteDocument,
  UpdateInternalDocumentsEvent,
  UpdateInternalDocumentsEventOperationOneOf,
  InternalDocument,
  InternalDocumentUpdateOperation,
  DeleteByIdsOperation,
  DeleteByFilterOperation,
  InternalDocumentUpdateByFilterOperation,
  InternalUpdateExistingOperation,
  VersionedDocumentUpdateOperation,
  VersionedDeleteByIdsOperation,
  VersionedDocumentId,
  UpdateDocumentsEvent,
  UpdateDocumentsEventOperationOneOf,
  DocumentUpdateOperation,
  IndexDocument,
  DocumentPayload,
  DocumentImage,
  V1DeleteByIdsOperation,
  V1DeleteByFilterOperation,
  UpdateByFilterOperation,
  UpdateExistingOperation,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  SearchRequest,
  OrderingClauses,
  OrderingClause,
  SearchPaging,
  FacetClauses,
  FacetClause,
  FacetClauseClauseOneOf,
  HierarchicalFacet,
  HierarchicalFacetClauseOneOf,
  TermFacet,
  AggregationFacet,
  SearchProperty,
  SearchResponse,
  NextPageResponse,
  FacetsResponse,
  FacetsResponseResponseOneOf,
  FacetCountResponse,
  Value,
  TermAggregationResponse,
  MinAggregationResponse,
  MaxAggregationResponse,
  MinMaxAggregationResponse,
  HierarchicalAggregationResponse,
  SumAggregationResponse,
  FederatedSearchRequest,
  FederatedSearchResponse,
  FederatedSearchDocuments,
  SuggestRequest,
  SuggestResponse,
  FederatedSuggestRequest,
  FederatedSuggestResponse,
  FederatedSuggestDocuments,
  RelatedRequest,
  RelatedResponse,
  AutocompleteRequest,
  AutocompleteResponse,
  AutocompleteResponseValue,
  FederatedAutocompleteRequest,
  FederatedAutocompleteResponse,
  FederatedAutocompleteResults,
  TrendingRequest,
  TrendingResponse,
  TrendingItems,
  SearchOptions,
  FederatedSearchOptions,
  SuggestOptions,
  FederatedSuggestOptions,
  RelatedOptions,
  AutocompleteOptions,
  FederatedAutocompleteOptions,
  TrendingOptions,
} from './search-v1-sitedocument-site-search.universal.js';
export {
  VersioningModeWithLiterals,
  EnumWithLiterals,
  WebhookIdentityTypeWithLiterals,
  DirectionWithLiterals,
  AggregationWithLiterals,
} from './search-v1-sitedocument-site-search.universal.js';
